import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function QuarterThousandIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4031" data-mp="1vzb78gxhpkrn">
      <div className="relative w-full h-full bg-gradient-to-br from-amber-100 to-orange-200 overflow-hidden" data-id="element-4032" data-mp="2onqiqthexky8">
        {/* Background: Target rings */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4033" data-mp="2anftfuvr4ef6">
          <circle cx="100" cy="95" r="70" fill="#FDE68A" opacity="0.4" data-id="element-4034" data-mp="z7r6h3ihzfed" />
          <circle cx="100" cy="95" r="50" fill="#FCD34D" opacity="0.5" data-id="element-4035" data-mp="147lyxbhx8d1j" />
          <circle cx="100" cy="95" r="30" fill="#FBBF24" opacity="0.55" data-id="element-4036" data-mp="145sr3svknmry" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-4037" data-mp="lsnhh0ttx66t">
          <div className="w-[68%] h-[68%] flex items-center justify-center" data-id="element-4038" data-mp="gu3wp3qz20g1">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4039" data-mp="vql3ris4osws" />
          </div>
        </div>

        {/* Foreground: "250" banner */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4040" data-mp="1eegdmrkmdmkm">
            <path d="M-10 32 Q100 60 210 32 L210 50 Q100 78 -10 50 Z" fill="#F97316" data-id="element-4041" data-mp="1ngzh9dw8c37x" />
            <text x="100" y="50" textAnchor="middle" fontFamily="sans-serif" fontSize="20" fontWeight="900" fill="white" data-id="element-4042" data-mp="1jchxhepvdpx5">
              250
            </text>
            <circle cx="34" cy="150" r="7" fill="#FBBF24" data-id="element-4043" data-mp="20f6yogl7dlvz" />
            <circle cx="166" cy="158" r="9" fill="#F59E0B" data-id="element-4044" data-mp="256f8veucxba7" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}